// Division colours for the whole app.
//
// This file is now a thin adapter over the single palette module
// (src/lib/divisionPalette.ts). Do not add hex values here.
//
// Colour keys on the division STRING. With no stored colour the palette hash
// picks one deterministically, so 16u looks the same on every page and reload.

import {
  resolveDivisionColors,
  type ThemeMode,
} from '@/lib/divisionPalette';

export type DivisionColor = {
  /** Saturated edge stripe / dot colour. */
  border: string;
  /** Card tint. */
  bg: string;
  /** Text colour, ≥4.5:1 on `bg`. */
  text: string;
  dot: string;
  swatchId: string;
  isAuto: boolean;
};

/**
 * @param division  the division string, e.g. "16u"
 * @param stored    schedule_color from event_division_format_overrides, or null for auto
 * @param mode      theme; defaults to whatever <html> currently says
 */
export function getDivisionColor(
  division: string | null | undefined,
  stored?: string | null,
  mode?: ThemeMode,
): DivisionColor {
  const m: ThemeMode =
    mode ??
    (typeof document !== 'undefined' && document.documentElement.classList.contains('dark')
      ? 'dark'
      : 'light');
  const c = resolveDivisionColors(division, stored ?? null, m);
  return { border: c.stripe, bg: c.tint, text: c.text, dot: c.stripe, swatchId: c.swatchId, isAuto: c.isAuto };
}
